import { useState } from 'react';

const Testimonials = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const [, setAnimationDirection] = useState('');

  const testimonials = [
    {
      id: 0,
      quote: "Mon fils a construit son premier robot et a présenté son projet au Lab. Il a pris confiance en lui et veut maintenant poursuivre en ingénierie!",
      name: "Ali Tufan",
      position: "Product Manager, Apple Inc",
      avatar: "/home-3/testimonials/1.png"
    },
    {
      id: 1,
      quote: "Mon fils a construit son premier robot et a présenté son projet au Lab. Il a pris confiance en lui et veut maintenant poursuivre en ingénierie!",
      name: "Sarah Johnson",
      position: "UX Designer, Google",
      avatar: "/home-3/testimonials/2.png"
    },
    {
      id: 2,
      quote: "Mon fils a construit son premier robot et a présenté son projet au Lab. Il a pris confiance en lui et veut maintenant poursuivre en ingénierie!",
      name: "Michael Chen",
      position: "Software Engineer, Microsoft",
      avatar: "/home-3/testimonials/3.png"
    },
    {
      id: 3,
      quote: "Mon fils a construit son premier robot et a présenté son projet au Lab. Il a pris confiance en lui et veut maintenant poursuivre en ingénierie!",
      name: "Emma Wilson",
      position: "Marketing Director, Amazon",
      avatar: "/home-3/testimonials/4.png"
    },
    {
      id: 4,
      quote: "Mon fils a construit son premier robot et a présenté son projet au Lab. Il a pris confiance en lui et veut maintenant poursuivre en ingénierie!",
      name: "David Kim",
      position: "Data Scientist, Netflix",
      avatar: "/home-3/testimonials/5.png"
    }
  ];

  const handleTestimonialChange = (index) => {
    if (index === activeTestimonial) return;

    // Détermine la direction de l'animation
    setAnimationDirection(index > activeTestimonial ? 'slide-out-left' : 'slide-out-right');

    // Après un court délai pour permettre l'animation de sortie, change le témoignage et anime l'entrée
    setTimeout(() => {
      setActiveTestimonial(index);
      setAnimationDirection(index > activeTestimonial ? 'slide-in-right' : 'slide-in-left');

      // Réinitialise la direction après l'animation
      setTimeout(() => setAnimationDirection(''), 500);
    }, 10);
  };

  return (
    <section className="py-12 md:py-16 lg:py-24 px-4">
      <div className="container mx-auto">
        {/* Title */}
        <div className="flex flex-col items-center text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-4xl text-dark-1 font-bold mb-3">Success Stories / Témoignages Parents + Kids</h2>
        </div>

        {/* Slider */}
        <div className="flex justify-center">
          <div className="w-full max-w-4xl">
            {/* Testimonial */}
            <div className={`bg-white w-full p-6 md:p-8 rounded-lg text-center relative overflow-hidden dark:bg-dark-1`}>
              <div className="flex justify-center mb-4 md:mb-6">
                <img src="/misc/quote.svg" alt="quote" className="w-12 h-12 md:w-16 md:h-16" />
              </div>
              <p className="text-lg md:text-xl lg:text-[24px] font-medium">
                {testimonials[activeTestimonial].quote}
              </p>
              <div className='mt-8 md:mt-[60px]'>
                <h5 className="text-base md:text-[17px] font-medium">{testimonials[activeTestimonial].name}</h5>
                <p className="text-gray-600 dark:text-gray-300 text-sm md:text-[15px] mt-1 md:mt-2">
                  {testimonials[activeTestimonial].position}
                </p>
              </div>
            </div>

            {/* Pagination */}
            <div className="flex justify-center mt-8 md:mt-12 space-x-3 md:space-x-6 overflow-x-auto py-2">
              {testimonials.map((testimonial, index) => (
                <button
                  key={testimonial.id}
                  onClick={() => handleTestimonialChange(index)}
                  className={`flex-shrink-0 focus:outline-none rounded-full p-1 md:p-2
                  ${activeTestimonial === index ? 'border-2 border-dark-1 dark:border-dark-4' :
                      'border-2 dark:border-dark-1 opacity-70 hover:opacity-100'}`}
                >
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-12 h-12 md:w-16 md:h-16 rounded-full object-cover"
                  />
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;